module.exports = __webpack_public_path__ + "static/media/SortNew.dfcfdd05.svg";